//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RecordVue from './tabItem/Record.vue';
import SupplierVue from './tabItem/Supplier.vue';
import ProductVue from './tabItem/Product.vue';
export default {
  name: 'ProductConfig',
  components: {
    RecordVue: RecordVue,
    SupplierVue: SupplierVue,
    ProductVue: ProductVue
  },
  data: function data() {
    return {
      activeName: 'SupplierVue',
      dialogFormVisible: false,
      id: null
    };
  },
  methods: {
    open: function open(row) {
      this.id = row.id;
      this.dialogFormVisible = true;
    },
    close: function close() {
      this.id = null;
      this.dialogFormVisible = false;
    }
  }
};